import { gql } from '@apollo/client';

export const ANSWER_SPOUSE_LIVING_STATUS = gql`
  mutation answerSpouseLivingStatus($answer: Boolean!) {
    answerSpouseLivingStatus(input: { isSameHousehold: $answer }) {
      questions {
        id
        status
      }
      request {
        id
        profile {
          id
          spouseLivingStatus {
            id
            isSameHousehold
          }
        }
      }
    }
  }
`;
